import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material';
import styles from './CalcAccordion.module.scss';

const CustomizedAccordion = styled(Accordion)(() => ({
  '&.MuiAccordion-root': {
    borderRadius: '16px',
    width: '100%',
    padding: '10px',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
  },
  boxShadow: 'none',
}));

const CalcAccordion = (props) => {
  const { logo, title, children, titleStyle } = props;
  return (
    <div style={{ marginBottom: 20 }}>
      <CustomizedAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ padding: '0px', margin: '0px' }}
        >
          <div className={titleStyle ?? styles.summary}>
            {logo && <div className={styles.logo}>{logo}</div>}
            {title && <h1 className={styles.title}>{title}</h1>}
          </div>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </CustomizedAccordion>
    </div>
  );
};

export default CalcAccordion;
